// import "../styles/globals.css";
import React, { useEffect } from "react";
import Layout from "../containers/Layout";
import { initializeLocaleSetting } from "MMT-UI/helpers/localeHelper/LocaleSetting";
import { checkIsBot, getCountryCurrencyMap, getEntityType } from "../utils/CommonUtils";
import { getIntlCountryByUrlPhrase } from "../utils/dbUtils";
import { nextToExpress } from "../utils/nextToExpress";
import { visitorIdNode, getVisitorIdNode } from "@growth/visitor-id/node";
import init from "MMT-UI/init";

function checkTrackingCookie(req) {
  try {
    const cookies = req.headers.cookie || '';
    const cookiePairs = cookies.split(';');
    
    for (let cookie of cookiePairs) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'track' && value === 'true') {
        return true;
      }
    }
    return false;
  } catch (error) {
    console.error('Error checking tracking cookie:', error);
    return false;
  }
}

export default function App({ Component, pageProps, localeSettings }) {
  pageProps = { ...pageProps, localeSettings };
  if (!localeSettings) {
    return null;
  }
  const { isGoibibo = false, isDeviceMobile = false } = pageProps?.data || {};
  return (
    <div className={`${isGoibibo ? "isGi " : ""}${isDeviceMobile ? "pwa" : ""}`}>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </div>
  );
}

async function intialiseAppLocaleSettings(params) {
  const { req, res, isBot, currentDomainName, param, isIntl } = params || {};
  let language = "eng";
  if (param) {
    if (isIntl && param.length === 3) {
      language = param[1];
    } else if (!isIntl && param.length === 2) {
      //Language case for domestic
      language = param[0];
    }
  }
  if (currentDomainName?.indexOf("goibibo.com") > -1) {
    let giLanguage = `en`;
    if (param) {
      if (param.length === 2) {
        //Language case for domestic
        giLanguage = param[0];
      }
    }
    return {
      currency: "INR",
      isGlobalFlagEnabled: false,
      isGoibibo: true,
      language: giLanguage,
      region: "IN",
      userCountry: "IN",
      userCurrency: "INR",
    };
  }

  let commonLocaleSettings = await initializeLocaleSetting(req, res);
  if (isBot) {
    let botSettings = await createCommonSettingForBot(req, res, currentDomainName, param, isIntl);
    commonLocaleSettings = { ...commonLocaleSettings, ...botSettings, manualConfig: true };
  }
  commonLocaleSettings.language = language;
  return commonLocaleSettings;
}

async function createCommonSettingForBot(req, res, currentDomainName, query, isIntl) {
  const entityType = getEntityType(currentDomainName);
  if (entityType === "IN") {
    return {
      currency: "INR",
      entityName: "india",
      region: "IN",
      userCurrency: "INR",
      userCountry: "IN",
      isGlobalFlagEnabled: true,
    };
  }
  if (entityType === "AE") {
    return {
      currency: "AED",
      entityName: "global",
      region: "AE",
      userCountry: "AE",
      userCurrency: "AED",
      isGlobalFlagEnabled: true,
    };
  }
  if (entityType === "GLOBAL") {
    if (query.length > 1) {
      const countryCode = await getIntlCountryByUrlPhrase(query[0]);
      let currentCurrency = "USD";
      if (countryCode?.code) {
        const currencyMap = (await getCountryCurrencyMap()) || [];
        if (currencyMap && currencyMap?.length > 0) {
          currencyMap.forEach((item) => {
            if (item.code === countryCode?.code) {
              currentCurrency = item?.currency?.code;
            }
          });
        }
        return {
          currency: "AED",
          entityName: "global",
          region: "AE",
          userCountry: countryCode?.code,
          userCurrency: currentCurrency,
        };
      } else {
        return {
          currency: "AED",
          entityName: "global",
          region: "AE",
          userCountry: "AE",
          userCurrency: "USD",
        };
      }
    } else {
      return {
        currency: "AED",
        entityName: "global",
        region: "AE",
        userCountry: "AE",
        userCurrency: "AED",
      };
    }
  }
}

App.getInitialProps = async (context) => {
  let localeSettings = {};
  if (context?.ctx) {
    const { ctx } = context;
    const { req, res } = ctx || {};
    const blockRequestUrls = ["yolo.css.map"];
    let isBlocked = false;
    nextToExpress(context);
    try {
      const userAgent = req.headers["user-agent"] || "";
      const isBot = checkIsBot(userAgent);
      const hostnameSplit = req.headers.host.split(":");
      if (req?.headers?.host) {
        if (hostnameSplit.length > 1) {
          req.headers.host = hostnameSplit[0];
          req.hostname = hostnameSplit[0];
          req.host = hostnameSplit[0];
        }
      }
      const currentDomainName = hostnameSplit[0];
      const isGoibibo = currentDomainName.includes("goibibo.com");
      const { param } = req?.query || {};
      const isIntl = context?.router?.pathname.includes("international-flights");
      let dvid = "";

      // Set visitor ID middleware (creates cookie if it doesn't exist)
      if (isGoibibo) {
        const visitorIdMiddleware = visitorIdNode();
        visitorIdMiddleware(req, res, () => {});
        dvid = getVisitorIdNode(req);
      }
      else {
        dvid = init(req, res);
      }

      // Check for tracking cookie and add to request
      const hasTrackingCookie = checkTrackingCookie(req);
      if (hasTrackingCookie) {
        req.track = true;
      }

      localeSettings = await intialiseAppLocaleSettings({
        req,
        res,
        isBot,
        currentDomainName,
        param,
        isIntl,
      });

      blockRequestUrls.forEach((url) => {
        if (req.url.includes(url)) {
          isBlocked = true;
        }
        if (!localeSettings?.isGoibibo && !req.url.includes("flights")) {
          isBlocked = true;
        }

        if (
          localeSettings?.isGoibibo &&
          !(req.url.includes("flight") || req.url.includes("airlines"))
        ) {
          isBlocked = true;
        }
      });

      if (isBlocked) {
        return {};
      }

      localeSettings.userCountryName = localeSettings?.userCountryName || null;
      if (!localeSettings.logoUrl) {
        delete localeSettings.logoUrl;
      }
      localeSettings.dvid = dvid;
      // global.localeSettings = localeSettings;
      req.localeSettings = localeSettings;

      const isDomainDotCom = currentDomainName.includes('makemytrip.com');
      const userCurrency = localeSettings?.userCurrency || 'INR';
      if (isDomainDotCom && userCurrency !== 'INR') {
        res.setHeader("Cache-Control", "no-store, no-cache, must-revalidate");
      } else {
        res.setHeader("Cache-Control", "max-age=43200, public");
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Error on initializeLocaleOnServer => ", e);
    }
  }

  return { localeSettings };
};
